import * as Factory from 'factory.ts';
import { randomName, randomWord } from '@rtls/map/util/factory/factory.util';
import { BuiltInType } from '@rtls/core/models/base/built-in-type.model';

export const builtInTypeFactory = Factory.makeFactory<BuiltInType>({
	key: Factory.each(() => randomName()),
	translation: Factory.each(() => randomWord()),
});
